// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer__1fLe0","Active":"Active__R7s6E","Email":"Email__2pUJl"};